import { log, logSync } from '@/decorators'
import picturesApi from '@/api/picturesApi'

// initial state
const state = () => ({
  currentPictures: [],
  picturesClasses: [],
})

// getters
const getters = {
  currentPictures: (state) => {
    return state.currentPictures
  },
  picturesClasses: (state) => {
    return state.picturesClasses
  },
}
/* eslint-disable */
// actions
const actions = {
  @log('STORE - ACTION - PICTURES - GET FLUX ITEMS PICTURES', 3)
  async getFluxItemPictures({ commit, state }, params) {
    const res = await picturesApi.getFluxItemPictures(params)
    commit('SET_FLUXITEM_PICTURES', res.data)
  },
  @log('STORE - ACTION - PICTURES - PUSH PICTURE TO DATASET', 3)
  async pushPictureToDataset({ commit, state, rootState }, params) {
    console.log('Pushing photo to dataset', params)
    const res = await picturesApi.pushPictureToDataset(params)
  },
}

// mutations
const mutations = {
  @logSync('STORE - MUTATION - PICTURES - SET FLUX ITEM PICTURES', 4)
  SET_FLUXITEM_PICTURES(state, res) {
    state.currentPictures = res.currentPictures
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
